export const ROOM_TYPES = [
  "kitchen",
  "living",
  "bedroom",
  "entrance",
  "bathroom",
  "office",
  "garage",
  "kids",
] as const;
export type RoomType = (typeof ROOM_TYPES)[number];

export const GENERATION_TYPES = ["interior", "outdoor", "manual"] as const;
export type GenerationType = (typeof GENERATION_TYPES)[number];

export const STYLES = [
  "scandi",
  "modern",
  "japandi",
  "industrial",
  "midcentury",
  "minimal",
  "boho",
  "traditional",
] as const;
export type Style = (typeof STYLES)[number];

export const OUTDOOR_TYPES = ["garden", "patio", "backyard", "balcony", "facade"] as const;
export type OutdoorType = (typeof OUTDOOR_TYPES)[number];

export const OUTDOOR_STYLES = ["modern", "rustic", "tropical", "mediterranean", "minimal", "zen"] as const;
export type OutdoorStyle = (typeof OUTDOOR_STYLES)[number];

export const PALETTES = [
  "warm",
  "neutral",
  "cool",
  "earthy",
  "monochrome",
  "pastel",
  "dark",
] as const;
export type Palette = (typeof PALETTES)[number];

export const STRENGTHS = ["SAFE", "BALANCED", "CREATIVE"] as const;
export type Strength = (typeof STRENGTHS)[number];

export const ASPECT_RATIOS = [
  "1:1",
  "2:3",
  "3:2",
  "3:4",
  "4:3",
  "4:5",
  "5:4",
  "9:16",
  "16:9",
  "21:9",
] as const;
export type AspectRatio = (typeof ASPECT_RATIOS)[number];

export const RESOLUTION_TIERS = ["1k", "2k", "4k"] as const;
export type ResolutionTier = (typeof RESOLUTION_TIERS)[number];
